import React from "react";
const SvgVisible = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      fill="none"
      d="M21.4 12.3s-3.4 6.3-9.7 6.3c-6.3 0-9.7-6.3-9.7-6.3S5.4 6 11.7 6c6.3 0 9.7 6.3 9.7 6.3zm-6 0a3.8 3.8 0 11-7.5 0 3.8 3.8 0 017.6 0z"
    />
  </svg>
);
export default SvgVisible;
